export default function (alphaMin) {
	let nodes

	function force(alpha) {
		if (alpha < alphaMin) {
			nodes.forEach(node => {
				node.vx = 0
				node.vy = 0
				// only a node the user placed by hand keeps a hard pin, so the rest can rebalance
				// around whatever gets added to the graph next
				if (node.pinned) {
					node.fx = node.x
					node.fy = node.y
				}
			})
		}
	}

	force.initialize = function (_) {
		nodes = _.filter((n) => !n.hostId)
	}

	return force
}
